import { ButtonGroup } from '@timelyapp/react';
import React from 'react';
import styles from './FilterGroups.module.scss';

interface Props<
  T extends string | null,
  G extends {
    value: T;
    name: string;
  },
> {
  active: null | T;
  groups: Array<G>;
  onChange: (id: T, group: G) => void;
  useButtonGroup?: boolean;
}

const FilterGroups = <
  T extends string | null,
  G extends {
    value: T;
    name: string;
  },
>({
  active,
  groups,
  onChange,
  useButtonGroup = false,
}: Props<T, G>) => (
  <div className={styles.groupFilters}>
    {useButtonGroup ? (
      <ButtonGroup
        style={{ width: '100%' }}
        options={groups.map(group => ({
          label: group.name,
          value: group.value,
        }))}
        activeValue={active}
        onChange={value => onChange(value as T, groups.find(group => group.value === value)!)}
      />
    ) : (
      groups.map(group => (
        <button
          key={typeof group.value === 'string' ? group.value : 'null'}
          className={active === group.value ? styles.active : undefined}
          // size="small"
          data-group-filter-value={group.value}
          onClick={() => onChange(group.value, group)}
          type="button"
        >
          {group.name}
        </button>
      ))
    )}
  </div>
);

export default FilterGroups;
